import {get, post} from '@/axios';

 export const getAllGroup = p => post('group/getAllGroup', p);

 export const getGroupList = p => post('group/getGroupTree', p);

export const PageDevice = p => post('device/PageDevice', p);

 export const insertDevice = p => post('device/insertDevice', p);

 export const select = p => get('device/select', p);
 export const selectA = p => get('device/selectA', p);

 export const dynamicSelect = p => get('dynamic/select',p)

export const selectDeviceStrategy = p => get('dynamic/selectDeviceStrategy',p)

 export const groupDeviceTree = p => post('device/groupDeviceTree',p)

export const enterpriseDeviceTree = p => post('device/enterpriseDeviceTree', p);

export const getOrganizationList = p =>post('device/getOrganizationList',p)

export const organizationPageDevice = p =>post('device/organizationPageDevice',p)

export const organizationUpdate = p =>post('device/organizationUpdate',p)

 export const updateDevice = p => post('device/updateDevice', p);

 export const deleteDevice = p => post('device/deleteDevice', p);

 export const getDeviceExcel = p => post('device/getDeviceExcel', p);

 export const bindDevice = p => post('device/bindDevice', p);

 export const sendMessage = p => post('device/sendMessage', p);

 export const controlDevice = p => post('device/controlDevice', p);

 export const getPoint = p => post('track/getPoint', p);

 export const startControl = p => post('devicecontrol/start', p)

 export const stopControl = p => post('devicecontrol/stop', p)

 export const insertRemoteControlLog = p => post('device/insertRemoteControlLog', p)

 export const getRemoteLogList = p => post('device/getRemoteLogList', p)

 export const batchInsertDevice = p => post('device/batchInsertDevice', p)

 export const getAllDev = p => post('device/getAllDev', p)

 export const getPageList = p => post('deviceDiagnosis/getPageList', p)

 export const romDevicePage = p => post('device/romDevicePage', p)

 export const refreshStatus = p => get('device/refreshStatus', p)

 export const batchUpdateWarrantyPeriod = p => post('device/batchUpdateWarrantyPeriod', p);

 export const groupDeviceTreeGroup = p => post('device/groupDeviceTreeGroup',p);


// WEBPACK FOOTER //
// ./src/api/device/Information.js